module.exports = __webpack_public_path__ + "static/media/staff_man.30b6316f.jpg";